<template>
  <ul
    v-if="faqCategories.length > 1"
    class="accordion__filters"
  >
    <li
      v-for="(category, index) in faqCategories"
      :key="category.key"
      class="accordion-listitem"
    >
      <button
        class="accordion-listitem-btn"
        :class="{ 'is-active': currentIndex === index }"
        @click="myClick(index)"
      >
        {{ category }}
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'KfAccordionFilters',
  props: {
    faqCategories: {
      type: Array,
      default: null,
    },
    currentIndex: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isOpen: this.isInitiallyOpen,
    };
  },
  methods: {
    myClick(index) {
      // this.currentIndex = index;
      this.$emit('clicked', index);
    },
  },
};
</script>

<style lang="postcss"></style>
